<template>
  <v-row>
    <v-col cols="9">
      <input-upload
        id="input:imgLogoFile"
        v-model="image"
        :max-size-in-mb="5"
        accept="image/jpeg, image/png"
        label="Logotipo"
        :loading="loading"
      />
    </v-col>
    <v-col cols="3">
      <v-btn
        color="primary"
        outlined
        :loading="loading"
        :disabled="disabled"
        @click="upload()"
      >
        <v-icon>
          mdi-upload
        </v-icon>
        Salvar imagem
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import ServiceMixin from '@/app/arch/mixins/ServiceMixin';
import ProdutoRequest from '../../ProdutoRequest';

export default {
  name: 'UploadProductLogo',
  mixins: [ServiceMixin],
  props: {
    value: {
      type: Object,
      default() {
        return {
          imgLogoFile: '',
        };
      },
    },
  },
  data: () => ({
    image: {
      name: '',
      file: '',
      rawFile: null,
    },
    loading: false,
    requestClass: ProdutoRequest,
    swalConfig: {
      errorMessage: 'Falha ao fazer a upload do logotipo!',
      showSuccessSwal: false,
    },
  }),
  computed: {
    logo: {
      get() {
        return this.value.imgLogoFile;
      },
      set(img) {
        this.value.imgLogoFile = img;
      },
    },
    disabled() {
      return this.image.name === '';
    },
    getId() {
      return this.$route.params.id;
    },
  },
  watch: {
    logo: {
      immediate: true,
      handler(img) {
        this.image.name = img;
      },
    },
    'image.name': {
      immediate: true,
      handler(value) {
        if (!value) {
          this.logo = '';
          this.image = {
            name: '',
            file: '',
            rawFile: null,
          };
        }
      },
    },
  },
  methods: {
    upload() {
      this.handleLoading();
      this.makeUpload();
    },
    handleLoading() {
      this.loading = !this.loading;
    },
    makeUpload() {
      this.callService(
        this.requestClass.upload(
          this.getId,
          this.image.rawFile[0],
        ),
        this.handleLoading,
        this.swalConfig,
      );
    },
  },
};
</script>
